@if (displayOptions$ | async; as displayOptions) {
    @if (displayOptions.showCards) {
        <div class="card-container">
            @for (card of cards; track $index) {
                @if (card.routePath !== 'humidity' || displayOptions.hasHumidityMeters) {
                    <div class="card" [routerLink]="[card.routePath]" routerLinkActive="active">
                        <div class="card-icon">
                            <img
                                [ngSrc]="card.icon"
                                class="icon"
                                height="40"
                                width="40"
                                [alt]="card.title" />
                        </div>
                        <div class="card-title">
                            {{ card.title | translate: 'online' : 'monitoringAlarms' }}
                        </div>
                        <div class="card-subtitle">
                            {{ card.subtitle | translate: 'online' : 'monitoringAlarms' }}
                        </div>
                    </div>
                }
            }
        </div>
    } @else {
        <router-outlet></router-outlet>
    }
}
